import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { ToastrService } from 'ngx-toastr';
import { EnumAcaoRecurso } from '../../../../app/models/enum/acao-recurso.enum';
import { EnumRecursoPerfil } from '../../../../app/models/enum/recurso-perfil.enum';
import { IPermissaoModel } from '../../../../app/models/permissao.model';
import { AuthService } from '../../../../app/services/auth.service';
import { BaseListComponent } from "../../../shared/components/base-list/base-list.component";
import { PlanoAcaoService } from '../../../services/plano-acao.service';
import { IPlanoAcaoFiltroModel, IPlanoAcaoModel } from '../../../models/plano-acao-model';
import { PlanoAcaoFormComponent } from '../plano-acao-form/plano-acao-form.component';
import { PlanoAcaoImprimirComponent } from '../plano-acao-imprimir/plano-acao-imprimir.component';
import { PlanoAcaoFormPreencherComponent } from '../plano-acao-form-preencher/plano-acao-form-preencher.component';

@Component({
  selector: 'app-plano-acao-list',
  templateUrl: './plano-acao-list.component.html',
  styleUrls: ['./plano-acao-list.component.scss']
})
export class PlanoAcaoListComponent extends BaseListComponent implements OnInit, AfterViewInit {
  public dataSource = new MatTableDataSource<any>([])
  public selectedModel: any;
  public semDados = false;
  public filtro: IPlanoAcaoFiltroModel = {} as IPlanoAcaoFiltroModel;
  public pageEvent: any;
  public totalItens: number = 0;
  public numeroOsa: string = "";
  public displayedColumn: string[] = ['id', 'numeroOsa', 'ug', 'referencia', 'tipoAuditoria', 'prazoFinal', 'status'];
  public situacaoSelecionada: number = 2;
  public permissoes: IPermissaoModel;

  public listUnidadeGestoraId: number[] = [-1];

  // NOVO: Propriedade para armazenar os filtros aplicados
  private filtrosAtivos: IPlanoAcaoFiltroModel = {} as IPlanoAcaoFiltroModel;

  @ViewChild(MatPaginator) paginator: MatPaginator
  @ViewChild('tabela1') public tabela1: MatSort;

  constructor(
    private PlanoAcaoService: PlanoAcaoService,
    public route: ActivatedRoute,
    public toastr: ToastrService,
    public router: Router,
    public localeService: BsLocaleService,
    public matDialog: MatDialog,
    public authService: AuthService
  ) {
    super();
  }

  ngOnInit(): void {
    this.setarPermissoes();

    // NOVO: Escutar mudanças de filtros do componente de filtro
    this.PlanoAcaoService.filtrosAplicados$.subscribe(filtros => {
      if (filtros) {
        this.filtrosAtivos = { ...filtros };
        this.aplicarFiltros();
      }
    });
  }

  private setarPermissoes(): void {
    this.permissoes = new IPermissaoModel();
    this.permissoes.imprimir = this.authService.possuiPermissao(EnumRecursoPerfil.PlanoDeAcao, EnumAcaoRecurso.Imprimir);
    this.permissoes.visualizar = this.authService.possuiPermissao(EnumRecursoPerfil.PlanoDeAcao, EnumAcaoRecurso.Visualizar);
    this.permissoes.elaborar = this.authService.possuiPermissao(EnumRecursoPerfil.PlanoDeAcao, EnumAcaoRecurso.Elaborar);
    this.permissoes.preencher = this.authService.possuiPermissao(EnumRecursoPerfil.PlanoDeAcao, EnumAcaoRecurso.Preencher);
  }

  ngAfterViewInit() {
    this.configurarFiltro()
    this.obter();
  }

  sortData(sort) {
    this.filtro.colunaOrder = sort.active;
    this.filtro.direcao = sort.direction;
    this.obter();
  }

  public visualizar(id: number) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = "modal-plano-acao-elaborar";
    dialogConfig.width = "70vw";
    dialogConfig.maxHeight = "140vh";
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      titulo: "Visualizar",
      visualizar: true,
      id: id
    };

    const modal = this.matDialog.open(PlanoAcaoFormComponent, dialogConfig);

    modal.afterClosed().subscribe((data) => {
      if (data) {
      }
    });
  }

  public elaborar(id: number) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = "modal-plano-acao-elaborar";
    dialogConfig.width = "70vw";
    dialogConfig.maxHeight = "140vh";
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      titulo: "Elaborar",
      visualizar: false,
      id: id
    };

    const modal = this.matDialog.open(PlanoAcaoFormComponent, dialogConfig);

    modal.afterClosed().subscribe((data) => {
      if (data) {
        this.obter();
      }
    });
  }

  public preencher(id: number) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = "modal-plano-acao-preencher";
    dialogConfig.width = "70vw";
    dialogConfig.maxHeight = "140vh";
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      titulo: "Preencher",
      visualizar: false,
      id: id
    };

    const modal = this.matDialog.open(PlanoAcaoFormPreencherComponent, dialogConfig);

    modal.afterClosed().subscribe((data) => {
      if (data) {
        this.obter();
      }
    });
  }


  public filtrarPorNumero() {
    this.selectedModel = null;
    var filtro: IPlanoAcaoFiltroModel = { numeroOsa: this.numeroOsa } as IPlanoAcaoFiltroModel;
    this.PlanoAcaoService.obter(filtro);
  }

  public async obter(): Promise<void> {

    this.selectedModel = null;

    this.configurarFiltro();

    await this.setarFiltroUnidadesVinculadas();

    await this.PlanoAcaoService.obter(this.filtro);

    this.PlanoAcaoService.currentPlanoAcao.subscribe(res => {
      if (res.resultado && res.resultado.length > 0) {
        this.dataSource = new MatTableDataSource<any>(res.resultado);
        this.semDados = false;
      } else {
        this.dataSource = new MatTableDataSource<IPlanoAcaoModel>([]);
        this.semDados = true;
      }

      this.dataSource._updateChangeSubscription();
      this.totalItens = res.totalItens || 0;

      if (this.tabela1) {
        this.dataSource.sort = this.tabela1;
      }
    });
  }

  public async setarFiltroUnidadesVinculadas(): Promise<void> {

    const responsavelId = this.authService.usuario.id;

    try {
      const res = await this.PlanoAcaoService.obterUGsByResponsavelId(responsavelId);

      if (!res.dados || res.dados.length === 0) {
        this.listUnidadeGestoraId = [-1];
      }
      else {
        this.listUnidadeGestoraId = res.dados.map(u => u.value);
      }

      this.filtro.listUnidadeGestoraId = this.listUnidadeGestoraId;

    }
    catch (err) {
      this.toastr.error(err?.mensagem?.descricao ?? err, "Atenção");
    }
  }

  private configurarFiltro() {
    if (this.paginator) {
      this.filtro.pagina = this.paginator.pageIndex + 1;
      this.filtro.itensPorPagina = this.paginator.pageSize;
    }
  }

  pageChanged(e) {

    if (!this.filtro) {
      this.filtro = {} as IPlanoAcaoFiltroModel;
    }

    this.filtro.pagina = e.pageIndex + 1;
    e.pageIndex = this.filtro.pagina;
    this.filtro.itensPorPagina = e.pageSize;

    const temFiltroNumeroOsa = this.numeroOsa && this.numeroOsa.toString().trim() !== '';
    const temFiltrosAvancados = this.filtrosAtivos && Object.keys(this.filtrosAtivos).length > 0;

    if (temFiltrosAvancados) {
      const { pagina, itensPorPagina } = this.filtro;
      this.filtro = {
        ...this.filtrosAtivos,
        pagina,
        itensPorPagina
      };
    }

    if (temFiltroNumeroOsa) {
      this.filtro.numeroOsa = this.numeroOsa;
    }

    this.obter();
  }

  public selecionar(item: any) {

		this.selectedModel = !this.selectedModel || this.selectedModel.id !== item.id ? item : null;
  }

  private aplicarFiltros(): void {
    this.filtro = { ...this.filtrosAtivos };
    this.filtro.listUnidadeGestoraId = this.listUnidadeGestoraId;
    this.filtro.pagina = 1;
  }

  public imprimir(id: number) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = "modal-plano-acao-imprimir";
    dialogConfig.width = "90vw";
    dialogConfig.maxHeight = "90vh";
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      id
    };
    const modal = this.matDialog.open(
      PlanoAcaoImprimirComponent,
      dialogConfig
    );
    modal.afterClosed().subscribe((data) => {
    });
  }

  formatarTooltipCanc(element: any): string {

    const data = element?.dataCanc
      ? new Date(element.dataCanc).toLocaleDateString('pt-BR')
      : 'Data não informada';

    const nome = element?.responsavelNomeCanc || 'Usuário desconhecido';
    const comentario = element?.justificativaCanc || 'Sem justificativa';

    return `🗓 ${data}\n👤 ${nome}\n💬 ${comentario}`;
  }

  get podeElaborar(): boolean {
    const status = this.selectedModel?.status?.codigo;
    const finalizado = this.selectedModel?.monitoramentoFinMan === true || this.selectedModel?.monitoramentoFinAut === true;
    return !!this.selectedModel && (status === 1 || status === 3) && finalizado === false;
  } 

  get podePreencher(): boolean {
    const status = this.selectedModel?.status?.codigo;
    const finalizado = this.selectedModel?.monitoramentoFinMan === true || this.selectedModel?.monitoramentoFinAut === true;
    return !!this.selectedModel && (status == 4 || status == 7 || status == 8) && finalizado === false;
  }
  
  formatarTooltipMonitoramentoFin(element: any): string {
    return element?.justificativaMonitoramentoFin
      ? element.justificativaMonitoramentoFin.replace(/\r\n/g, '\n')
      : '';
  }  

}
